import React, { useState, useRef, useEffect } from 'react';
import { contextIcons } from './contextIcons';

interface ContextDropdownProps {
  selectedContext: string;
  setSelectedContext: (context: string) => void;
  disabled: boolean;
  is_study_participant: boolean | null;
}

const ContextDropdown: React.FC<ContextDropdownProps> = ({
  selectedContext,
  setSelectedContext,
  disabled,
  is_study_participant
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="input-group inline-group">
      <div className="context-dropdown" ref={dropdownRef}>
        <h2>Theme</h2>
        <div className="context-dropdown-container">
          <div className="select-wrapper">
            <select
              id="context-select"
              value={selectedContext}
              onChange={(e) => setSelectedContext(e.target.value)}
              disabled={disabled}
              className="search-input"
              onFocus={() => setIsOpen(true)}
            >
              <option value="">Select a theme</option>
              {Object.keys(contextIcons).map((context) => (
                <option key={context} value={context}>
                  {contextIcons[context]} {context}
                </option>
              ))}
            </select>
          </div>
          {/* {isOpen && (
            <div className="dropdown-list">
              {contexts.map((context) => (
                <label key={context}>
                  <input
                    type="radio"
                    checked={selectedContext === context}
                    onChange={() => setSelectedContext(context)}
                  />
                  {context}
                </label>
              ))}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ContextDropdown;